import type { StatKey } from "../types";

export function StatIcon({ k, className }: { k: StatKey; className?: string }) {
  const props = { className, "aria-hidden": true };
  switch (k) {
    case "cities":
      return (
        <svg {...props} width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 21V11l5-3v3l5-3v13h-3v-4H8v4H3zm12 0V8.5L21 5v16h-6zm2-2h2v-2h-2v2zm0-4h2v-2h-2v2zm0-4h2V9h-2v2z" />
        </svg>
      );
    case "locations":
      return (
        <svg {...props} width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2c-4.418 0-8 3.582-8 8 0 5.5 8 12 8 12s8-6.5 8-12c0-4.418-3.582-8-8-8zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
        </svg>
      );
    case "ac":
    case "dc":
      return (
        <svg {...props} width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />
        </svg>
      );
  }
}
